import { render } from "./HomeBrandStory.vue?vue&type=template&id=38e4ddf0"
import script from "./HomeBrandStory.vue?vue&type=script&lang=js"
export * from "./HomeBrandStory.vue?vue&type=script&lang=js"

import "./HomeBrandStory.vue?vue&type=style&index=0&id=38e4ddf0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__